import PropTypes from 'prop-types'
import { Fade } from 'react-awesome-reveal'
import { keyframes } from '@emotion/react'

import s from './TextBlock.module.css'

function TextBlock({ text = '', useTermsStyling = [], globalTextColour = '' }) {
  const customAnimation = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, 20px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`

  return (
    <Fade cascade keyframes={customAnimation} duration={500} triggerOnce>
      <div
        className={
          useTermsStyling && useTermsStyling[0] === 'yes'
            ? s.containerTerms
            : s.container
        }
      >
        <div
          className={
            useTermsStyling && useTermsStyling[0] === 'yes'
              ? s.contentTerms
              : s.content
          }
          dangerouslySetInnerHTML={{ __html: text }}
          style={{ color: globalTextColour ? globalTextColour : 'initial' }}
        />
      </div>
    </Fade>
  )
}

TextBlock.propTypes = {
  text: PropTypes.string,
  globalTextColour: PropTypes.string,
  useTermsStyling: PropTypes.array,
}

export default TextBlock
